var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    style: {
      enableBackground: "new 0 0 283.46 283.46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.12,172.68c0,22.04-17.52,39.92-39.12,39.92H75.86c-26.24,0-47.51-21.72-47.51-48.49 s21.28-48.49,47.51-48.49c0.38,0,0.79,0,1.17,0.03c9.53-26.16,34.22-44.78,63.2-44.78c35.23,0,64.18,27.61,67.15,62.83 c2.78-0.64,5.65-0.97,8.62-0.97C237.6,132.73,255.12,150.61,255.12,172.68z",
    stroke: "blue",
    strokeWidth: 3,
    fill: "blue"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.73,28.35c-40.48,0-73.29,32.81-73.29,73.29c0,40.48,73.29,153.48,73.29,153.48s73.29-113,73.29-153.48 C215.02,61.16,182.21,28.35,141.73,28.35z M141.73,125.97c-16.58,0-30.03-13.44-30.03-30.03c0-16.58,13.44-30.03,30.03-30.03 s30.03,13.44,30.03,30.03C171.76,112.53,158.32,125.97,141.73,125.97z",
    stroke: "blue",
    strokeWidth: 3,
    fill: "blue"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 141.73,
    cy: 89.93,
    r: 61.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.89,255.12c0-48.67,45.59-88.13,101.84-88.13s101.84,39.46,101.84,88.13H39.89z",
    stroke: "blue",
    strokeWidth: 3,
    fill: "blue"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/핀.2f89d94ded73e079c7167a76ca25f491.svg";
export { ForwardRef as ReactComponent };